import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { tap } from 'rxjs';

import { injectDevFlagSignal } from '@core/tellent-dev-flags-logic';
import {
  AddMemberDialogComponent,
  AddMemberService,
  UserInvitationFlowFacade,
} from '@core/tellent-smart-ui';
import {
  TellentDevFlag,
  TellentWebComponent,
  UserInvitationDialogOutput,
} from '@core/tellent-types';
import { useProtectedControlsCallback } from '@core/user-interface-routing-logic';

import { DialogWrapComponent } from '../dialog/dialog-wrap.component';

@Component({
  selector: 'x-add-member-dialog',
  template: ``,
  imports: [],
})
export class TellentAddMemberDialogWrapComponent extends DialogWrapComponent<
  AddMemberDialogComponent,
  UserInvitationDialogOutput
> {
  private readonly protectedControls = useProtectedControlsCallback();
  private readonly svc = inject(AddMemberService);
  private readonly usersWithoutEmails = injectDevFlagSignal(TellentDevFlag.UsersWithoutEmails);
  private readonly smootherUserCreationFlowService = inject(UserInvitationFlowFacade);
  #open = false;

  public readonly component = AddMemberDialogComponent;
  public readonly config = {
    containerOptions: { fullscreenOnMobile: true },
    closeGuard: () => this.protectedControls(() => true),
  };

  protected async openDialog() {
    if (this.#open) return;

    this.#open = true;

    if (this.usersWithoutEmails()) {
      this.smootherUserCreationFlowService
        .startNewMemberFlowAsTellentClientCompatibleStream()
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          tap(() => (this.#open = false)),
        )
        .subscribe(value => this.afterClosed.emit(value));
    } else {
      this.svc
        .openAddMemberDialogAsTellentClientCompatibleStream(this.config)
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          tap(() => (this.#open = false)),
        )
        .subscribe(value => this.afterClosed.emit(value));
    }

    return Promise.resolve(void 0);
  }
}

export type TellentAddMemberDialogWebComponent = TellentWebComponent<
  TellentAddMemberDialogWrapComponent,
  'afterClosed' | 'open'
>;
